export const nature = [
    'Manufacturer' ,
    'Traders' ,
    'Services Providers' ,
    'Shops' ,
    'Restaurant/Foods Related Services' ,
    'Importer/Exporter' ,
    'Others' 
];